import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Button from "@/components/atoms/Button";
import H3 from "@/components/atoms/text/H3";
import Label from "@/components/atoms/text/Label";
import Para from "@/components/atoms/text/Para";
import { PlansTickIcon, CircleInfoIcon } from "@/components/atoms/Icons";
import {
  getCookieValue,
  getSiteInfo,
  getSignupURL,
  constructSignupURL,
  calculateDiscountedPrice,
} from "@/utils/commonUtil";
import { isMobileScreen } from "@/utils/functions";

const PlansCard = ({
  cardTitle,
  minsPlusChat,
  price,
  setUpFee,
  additionalMins,
  features,
  btnVariant = "ghost",
  planId,
  isMostPopularValue = false,
  isBestValue = false,
  dataTestId,
}) => {
  const [signupURL, setSignupURL] = useState(getSiteInfo().DIRECT_SIGNUP_URL);
  const [isMobile, setIsMobile] = useState(null);
  const router = useRouter();

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  useEffect(() => {
    const url = getSignupURL(router, getCookieValue, getSiteInfo);
    setSignupURL(url);
  }, [router]);

  const discountedPrice = calculateDiscountedPrice(
    price,
    planId,
    router.pathname
  );
  const isDiscountPlan = discountedPrice !== price;

  return (
    <div className={`plans__card ${isMostPopularValue ? "card--border" : ""}`}>
      <div className="bc-blue-light inset-both-md-d inset-both-sm pv-3 ps-r">
        <Label size="xl" color="blue" className="text--mont fw-semibold">
          {cardTitle}
        </Label>
      </div>
      <div
        className={`bc-white inset-both-md-d inset-both-sm ${
          isBestValue && isMostPopularValue && !isMobile
            ? "pt-7 pb-8"
            : "pt-5 pb-7"
        }`}
      >
        <Para
          desktopSize="md"
          mobileSize="md"
          className="mb-4 text--mont fw-semibold"
        >
          {minsPlusChat}
        </Para>
        <H3
          desktopSize={isBestValue ? "lg" : "md"}
          mobileSize="md"
          className={`bold fx mb-1 ${isBestValue ? "lh-46" : "lh-40"}`}
        >
          <sup className="fw-semibold text text--md">$</sup>
          {isDiscountPlan ? (
            <>
              {Number(discountedPrice).toFixed(2)}
              <span className="text text--md to-bottom fw-semibold line-through tc-grey-dark">
                ${price} /month
              </span>
            </>
          ) : (
            <>
              {price}
              <span className="text text--md to-bottom fw-semibold">
                /month
              </span>
            </>
          )}
        </H3>
        <Para color="grey" desktopSize="sm" mobileSize="sm" className="mb-7">
          {setUpFee} setup fee
        </Para>
        <Button
          size="md"
          variant={btnVariant}
          href={constructSignupURL(signupURL, planId, router.pathname)}
          className="btn--lg mb-4"
          data-testid={dataTestId}
        >
          Choose
        </Button>
        <Para
          color="grey"
          desktopSize="sm"
          mobileSize="sm"
          className="mb-7 ta-center fx fx--cv fx--ch"
        >
          <CircleInfoIcon />
          &nbsp;${additionalMins} per additional minute or chat
        </Para>
        <ul className="fx fx--c">
          {features?.map((feature, idx) => (
            <li
              key={idx}
              className={`fx fx--cv ${
                idx === features.length - 1 ? "" : "mb-2"
              }`}
            >
              <PlansTickIcon />
              <Para
                desktopSize="md"
                mobileSize="md"
                className="ml-1"
                dangerouslySetInnerHTML={{ __html: feature }}
              />
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .plans__card {
          overflow: hidden;
          border-radius: 8px;
          box-shadow: 0px 4px 22px 4px rgba(50, 112, 216, 0.12);
        }
        .card--border {
          outline: 2px solid #3270d8;
        }
        .price {
          sup {
            margin-top: 4px;
          }
          span {
            margin-bottom: 4px;
          }
        }
      `}</style>
    </div>
  );
};

export default PlansCard;
